import { put, select, takeLatest } from 'redux-saga/effects';
import {
  CARD_VIEW_CONTENT_LOADED,
  CARD_VIEW_MOUNTED,
  DETAILS_VIEW_CONTENT_LOADED,
  DETAILS_VIEW_MOUNTED,
} from '../actions';
import { getCardViewConfig } from '../../check-coverage/selectors/checkCoverageSelectors';

function* cardViewMounted(): any {
  const config = yield select(getCardViewConfig, 'emma-ps-value-added-service');
  yield put({ type: CARD_VIEW_CONTENT_LOADED, config });
}

function* detailsViewMounted(): any {
  const config = yield select(getCardViewConfig, 'emma-ps-value-added-service');
  yield put({ type: DETAILS_VIEW_CONTENT_LOADED, config });
}

function* exclusiveOfferSaga(): any {
  yield takeLatest(CARD_VIEW_MOUNTED, cardViewMounted);
  yield takeLatest(DETAILS_VIEW_MOUNTED, detailsViewMounted);
}

export default exclusiveOfferSaga;
